import {
  createStore,
  compose,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {
  persistStore,
  persistReducer,
} from 'redux-persist';
import localforage from 'localforage';
import {encryptTransform} from 'redux-persist-transform-encrypt';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import rootReducer from './store-reducers-index'; 

const middlewares = [];

middlewares.push(thunk);

if (process.env.NODE_ENV !== 'production') {
  const logger = createLogger({
    collapsed: true,
    duration: true,
  });
  middlewares.push(logger);
}

const persistConfig = {
  key: 'root',
  storage: localforage,
  stateReconciler: autoMergeLevel2,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_PERSIST_KEY,
      onError: (error) => {console.error(error)},
    }),
  ],
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(pReducer, compose(applyMiddleware(...middlewares)));

export const persistor = persistStore(store);
